export const MALL_DEFAULT_PAGE_SIZE = 20

export const MALL_SORT = {
  RECOMMEND: 'recommend',
  DATE: 'date',
  PRICE: 'price',
  STOCK: 'stock',
}

export const ORDER = {
  DESCEND: 'desc',
  ASCEND: 'asc',
}

export const DEFAULT_MALL_SORT = MALL_SORT.RECOMMEND
export const DEFAULT_MALL_ORDER = ORDER.DESCEND

export const MALL_SORT_KEY = {
  [MALL_SORT.RECOMMEND]: 'sort_by_recommend',
  [MALL_SORT.DATE]: 'sort_by_date',
  [MALL_SORT.PRICE]: 'sort_by_price',
  [MALL_SORT.STOCK]: 'sort_by_stock',
}
